import { useEffect, useState, useCallback } from "react";
import { z } from "zod";
import { fetchBillingCycleDay } from "../requests";
import { useMmToken } from "./useMMToken";

const billingCycleDayZod = z.object({
  accountId: z.string(),
  billCycleDay: z.number(),
});
type BillingCycleDay = z.infer<typeof billingCycleDayZod>;

export const useBillCycleDay = (isAnniversaryBilling: boolean) => {
  const accessToken = useMmToken();
  const [billCycleDay, setBillCycleDay] =
    useState<BillingCycleDay["billCycleDay"]>(0);

  const initBillCycleDay = useCallback(async (token: string) => {
    const response = await fetchBillingCycleDay(token);
    if (!Array.isArray(response)) {
      const parsed = billingCycleDayZod.safeParse(response);
      if (parsed.success) {
        setBillCycleDay(parsed.data.billCycleDay);
      } else {
        console.error("fetchBillingCycleDay_failedToParse: ", parsed.error);
      }
    } else {
      console.error("fetchBillingCycleDay_error", response);
    }
  }, []);

  useEffect(() => {
    if (accessToken && !billCycleDay && isAnniversaryBilling) {
      initBillCycleDay(accessToken);
    }
  }, [accessToken, initBillCycleDay, billCycleDay, isAnniversaryBilling]);

  if (!isAnniversaryBilling) return 1;

  return billCycleDay;
};
